import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 822CF3D7-FEB4-4988-A037-0866756D4ADE
 * name chair-rolling
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chair-rolling.svg
 * tags
 * - Home Automation 
 */
export const ChairRollingIcon = createSvgIcon(<><path d="M22 10V13H19V10H22M2 13H5V10H2V13M17 5C17 3.9 16.1 3 15 3H9C7.9 3 7 3.9 7 5V13H17V5M7 15H6V17H11V18L7 22H9.8L12 19.8L14.2 22H17L13 18V17H18V15H7Z" /></>, 'ChairRollingIcon');
export default ChairRollingIcon